import Message from '__core/shared/model/message/Message';
import { MessageType } from '__core/shared/model/message/Message.enum';
import stMessagesList from './messagesList.component';
import messagesController from './messages.controller';
import stMessageEditTrigger from './messageEditTrigger.component';
import stMessageEdit from './messageEdit.component';

export default angular
  .module('st.Message', ['st.Core', 'angular-cache'])
  .factory('Message', () => Message)
  .factory('MessageType', () => MessageType)
  .service('messageService', (Message, dataService) => ({
    createMessage: (doc) => dataService.createDocument(Message, doc),
    readMessage: (doc) => dataService.readDocument(Message, doc),
    updateMessage: (doc) => dataService.updateDocument(Message, doc),
    deleteMessage: (doc) => dataService.deleteDocument(Message, doc)
  }))
  .controller('messagesController', messagesController)
  .component('stMessagesList', stMessagesList)
  .component('stMessageEditTrigger', stMessageEditTrigger)
  .component('stMessageEdit', stMessageEdit)
  .service(
    'messagesService',
    ($http, $rootScope, CacheFactory, dataService, Message, MESSAGE) => {
      let cache;
      if (!CacheFactory.get(MESSAGE.CACHE.NAME)) {
        cache = CacheFactory(MESSAGE.CACHE.NAME, MESSAGE.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || MESSAGE.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params, 'getAvailable'),
            params?.ignoreCache === true,
            Message.build,
            $http.get,
            MESSAGE.API.AVAILABLE,
            { params }
          )
      };
    }
  )
  .constant('MESSAGE', {
    API: {
      AVAILABLE: '/api/v1/messages/available/'
    },
    CACHE: {
      NAME: 'messagesCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
